import { GET_PINVOICES } from "../actions/actionTypes";

const initialState = {
    results: [],
    total: 0,
};
export const PinvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PINVOICES:
            return {
                ...state,
                results: action.payload,
                total: action.total
            };
        default:
            return state;
    }
};